import { z } from "zod";
import { apiClient } from "../client";

export const getRentalPaymentSecret = async (rentalId: string) =>
  z
    .object({ payment_secret: z.string() })
    .parse((await apiClient.post(`v1/rentals/${rentalId}/create_stripe_intent`)).data);
